import AppModel from "../../../../../shared/src/ranj/app/core/AppModel";
import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class InfoPanelView extends AbstractView {

    constructor(target, languagePack, gameAssets) {
        super(target);
        this._languagePack = languagePack;
        this._gameAssets = gameAssets;

        this._panel = this._target.contents;
        this._toggle = this.createButton(this._panel.toggle, this._handleToggle.bind(this));
        this._panel.titleTextfield.text = this.getText("info.title");

        //block clicks through panel, quick and dirty
        this._target.bg.addEventListener("click", () => { });

        this._animating = false;
        this._openY = 0;
        this._closeY = target.contents.y;
        this._panel.y = this._closeY;
        this._toggle.setSelected(true);

        this._forcingReadAll = false;

        this.close(true);
    }

    set enabled(value) {
        this._toggle.setEnabled(value);
    }

    forceReadAll() {
        this.enabled = false;
        this._forcingReadAll = true;
        this._allRead = false;
        this.scheduleNudge();
    }

    stopNudges() {
        this.killDelayedCall(this._nudgeTimeout);
        if (this._nudgeTarget) {
            createjs.Tween.removeTweens(this._nudgeTarget);
            this._nudgeTarget.alpha = 1;
            this._nudgeTarget = null;
        }
    }

    scheduleNudge(delay = 6000) {
        this._nudgeTimeout = this.callDelayed(this.nudge.bind(this), delay / AppModel.speedFactor);
    }

    nudge() {
        this.killDelayedCall(this._nudgeTimeout);
        this._nudgeTarget = this._allRead ? this._panel.toggle : this._panel.nextButton
        this.blink(this._nudgeTarget, 3);
        this.scheduleNudge(8500);
    }

    blink(target, count = 2) {
        target.alpha = 1;
        const props = { loop: count * 2 - 1, bounce: true };
        createjs.Tween.get(target, props).to({ alpha: 0 }, 500);
    }

    setPage(index) {
        this._pageIndex = Math.min(this._pageIds.length - 1, Math.max(0, index));

        const prefix = this._pageIds[this._pageIndex];
        const title = this.getText(prefix + ".title");
        const body = this.getText(prefix + ".body");
        this.setContent(title, body);

        this.stopNudges();
        if (this._forcingReadAll) {
            if (this._pageIndex == this._pageIds.length - 1) {
                this._allRead = true;
                this.enabled = true;
            }
            this.scheduleNudge();
        }
    }

    _handleToggle(e) {
        this.stopNudges();
        if (this._state != State.OPENED) {
            this.open();
        } else {
            this.close();
        }
    }

    open(instant = false) {
        if (this._state != State.OPENED) {
            this._animateTo(this._openY, State.OPENED, instant);
            this.dispatchEvent(InfoPanelView.OPEN);
        }
    }
    close(instant = false) {
        if (this._state != State.CLOSED) {
            this._animateTo(this._closeY, State.CLOSED, instant);
            this.dispatchEvent(InfoPanelView.CLOSE);
        }
    }

    _animateTo(goalY, stateAtEnd, instant) {
        const onComplete = () => {
            this._state = stateAtEnd;
            this._toggle.setSelected(this._state != State.OPENED);
        }
        const alpha = stateAtEnd == State.OPENED ? 1 : 0;
        if (instant) {
            this._panel.y = goalY;
            this._target.bg.alpha = alpha;
            onComplete();
        } else {
            const dur = Math.abs(this._panel.y - goalY) * .5;
            createjs.Tween.get(this._panel).to({ y: goalY }, dur, createjs.Ease.quadOut).call(onComplete);
            createjs.Tween.get(this._target.bg).to({ alpha: alpha }, dur, createjs.Ease.quadOut);
        }
    }


}


const State = { CLOSED: 0, CLOSING: 1, OPENING: 2, OPENED: 3 };

InfoPanelView.CLOSE = "InfoPanelView.CLOSE";
InfoPanelView.OPEN = "InfoPanelView.OPEN";